/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from 'react';
import { useStyles } from './CardHeader.styles';

export type CardHeaderProps = {
    title: string;
    description?: string;
};

export const CardHeader: React.FC<CardHeaderProps> = ({ title, description }) => {
    const styles = useStyles();

    return (
        <div className={styles.headerSection}>
            <div className={styles.headerTitle}>{title}</div>
            {description && (
                <div className={styles.headerDescription}>{description}</div>
            )}
        </div>
    );
};
